"use strict";
exports.__esModule = true;
exports.getParams = void 0;
/**
 * Get the params from the URL.
 * Returns null if there was a problem.
 */
function getParams() {
    var raw = new URLSearchParams(window.location.hash.slice(1));
    var params = {};
    raw.forEach(function (val, key) {
        params[key] = val;
    });
    if (params.action === null) {
        return null;
    }
    switch (params.action) {
        case "production": {
            if (params.item) {
                return {
                    action: "production",
                    item: params.item
                };
            }
            else
                return null;
        }
        case "consumption": {
            if (params.item) {
                return {
                    action: "consumption",
                    item: params.item
                };
            }
            else
                return null;
        }
        case "showPins": return { action: "showPins" };
        case "search": {
            if (params.search) {
                return {
                    action: "search",
                    search: params.search
                };
            }
            else
                return null;
        }
        default: return null;
    }
}
exports.getParams = getParams;
